import { createQueryKeys } from '@lukemorales/query-key-factory';
import { modemApis } from '../../apis/modem/apis';
import type { IGetModemDetailsParams, IGetModemsParams } from '../../apis/modem/types';
import type { IModem, IModemListResponse } from '../../types/modem';

export const modemsQueries = createQueryKeys('modems', {
  modemList: (params: IGetModemsParams) => ({
    queryKey: [params],
    queryFn: async (): Promise<{ data: IModemListResponse }> => {
      const response = await modemApis.getModemList(params);
      return response.data;
    },
  }),
  modemDetails: (params: IGetModemDetailsParams) => ({
    queryKey: [params.id],
    queryFn: async (): Promise<{ data: IModem }> => {
      const response = await modemApis.getModemDetails(params);
      return response.data;
    },
  }),
});
